import { usePermissions } from '@pankod/refine-core';
import { AdminUserRole } from 'interfaces';

export const useRole = () => {
  const { data: permissions } = usePermissions();
  const role = permissions?.role as AdminUserRole | undefined;

  return {
    role,
    isAdmin: role === 'admin',
    isManager: role === 'manager',
    isGuest: role === 'guest',
  };
};
